export function heroImagesSlider() {
    const $slider = $(".hero-images-slider");
    let sliderNav = "";
    let $current = "";
    let $total = "";


    $slider.each(function () {
        let $this = $(this);
        sliderNav = $this.next(".hero-images-slider-nav");
        $current = sliderNav.find('.current');
        $total = sliderNav.find('.total');
        $total.text($this.find(".item").length);
        $current.text("1");
        $this.slick({
            dots: true,
            appendDots: sliderNav,
            arrows: true,
            appendArrows: sliderNav,
            infinite: false,
            speed: 700,
            pauseOnHover: false,
            pauseOnDotsHover: false,
            autoplaySpeed: 5000,
            fade: true,
            cssEase: 'ease',
            slidesToShow: 1,
            slidesToScroll: 1,
        }).on('init reInit afterChange', function (event, slick, currentSlide) {
            let i = (currentSlide ? currentSlide : 0) + 1;
            $current.text(i);
            $total.text(slick.slideCount);
        });
    });
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            let slider = $(entry.target);
            slider.addClass("with-progress-animation");
            if (entry.isIntersecting) {
                slider.slick("slickPlay");
                slider.addClass("animation-play");
            } else {
                slider.slick("slickPause");
                slider.removeClass("animation-play");
            }
        });
    });
    $slider.each(function () {
        observer.observe(this);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/heroImagesSlider.js